export default {
	targets: {},

	clear() {
		this.targets = {};
	},

	add(id, x, y) {
		x = Math.round(x);
		y = Math.round(y);
		this.targets[id] = [x, y];
	},

	/** Register a caller-owned, already-rounded [x, y] array without
	 *  allocating. Hot-path variant of add() — the grid target pass reuses
	 *  one array per grid point across ticks (see ParticleGridTargets). */
	set(id, target: Array<number>) {
		this.targets[id] = target;
	},

	getTarget(id): Array<number> | null {
		return this.targets[id];
	}
};
